/**
 * Friendly URL builders. The API gives recipes a `slug` (derived from the
 * name) and profiles are addressed by username; either falls back to the id
 * when the API didn't supply one, and the old id links keep resolving.
 */
export function recipePath(recipe: { _id: string; slug?: string | null }, suffix = ''): string {
	return `/recipes/${encodeURIComponent(recipe.slug || recipe._id)}${suffix}`;
}

export function userPath(user: { _id: string; username?: string | null }): string {
	return `/users/${encodeURIComponent(user.username || user._id)}`;
}
